module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-stroke.c45f7de0.svg";